import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  countryLabel: {
    id: 'WX3NeV',
    defaultMessage: 'Country',
    description: 'Label for country dropdown',
  },
  fullNameLabel: {
    id: 'IMiYSM',
    defaultMessage: 'Full Name',
    description: 'Label for full name field',
  },
  companyNameLabel: {
    id: '+JEVl7',
    defaultMessage: 'Company',
    description: 'Label for company name field',
  },
  companyNameLabelOptional: {
    id: '3MOUFd',
    defaultMessage: 'Company (Optional)',
    description: 'Label for optional company name field',
  },
  emailLabel: {
    id: 'bGKAyO',
    defaultMessage: 'Email',
    description: 'Label for email field',
  },
  phoneNumberLabel: {
    id: 'OnH/Yk',
    defaultMessage: 'Phone number',
    description: 'Label for phone number field',
  },
});
